import { jsx, css } from '@emotion/react';
import ContentAndImage from '../oc-content-and-image';
import RichText from "../oc-rich-text"

const noMediaStyles = css`
  margin-left: 10%;
  margin-right: 10%;
  width: 80%;

  @media (max-width: 767px) {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
`

const PrimaryCTA = ({ className, heading, prehead, description, cta, image, video, ...other}) => {
  const hasMedia = image || video
  if(hasMedia) {
    return (
      <section className={className}>
        <ContentAndImage img={image.url} video={video} alt={image.alt} ratio="1-1">
          <span className="prehead h5"><RichText content={prehead}/></span>
          <h2><RichText content={heading}/></h2>
          <p><RichText content={description}/></p>
          {cta}
        </ContentAndImage>
      </section>
    )
  } else {
    return (
      <section className={className}>
        <div css={noMediaStyles}>
          <span className="prehead h5"><RichText content={prehead}/></span>
          <h2><RichText content={heading}/></h2>
          <p><RichText content={description}/></p>
          {cta}
        </div>
      </section>
    )
  }
};

export default PrimaryCTA
